import React from "react";

import {
  PageList,
  ENUM_FORM_DISPLAY,
  ENUM_FORM_LAYOUT_CONTAINER,
} from "../components/pageList";

import { useCellRender } from "../hooks/useCellRender";
import { useFormatter } from "../hooks/useFomatter";

import ActionCellRender from "../components/actionCellRender";

import { IconTrash, IconPencil, IconSettings } from "@tabler/icons";
import { NumberInput, TextInput, Select, Text, Textarea } from "@mantine/core";

import _ from "lodash";
import moment from "moment";
import { DatePicker } from "@mantine/dates";
import { DATA_INCENTIVE_TYPE } from "../data/options";
import { Card, Group } from "@mantine/core";
import OrderList from "../components/orderList";
import { useForceUpdate } from "@mantine/hooks";
import ReactJson from "react-json-view";

const AIPromptMessageRow = ({ item, form, name }) => {
  const forceUpdate = useForceUpdate();
  return (
    <Card>
      <ReactJson src={item} name="item" style={{ backgroundColor: "white" }} />
      <Select
        data={["system", "user"]}
        value={item.role}
        onChange={(value) => {
          item.role = value;
          forceUpdate();
        }}
      />
      <TextInput
        value={item.content}
        onChange={(e) => {
          item.content = e.target.value;
          forceUpdate();
        }}
      />
    </Card>
  );
};

const AIPrompt = () => {
  const apiEntity = "aiPrompt";
  const initialValues = {
    id: "",
    title: "",
    description: "",
    messages: [],
  };

  const tableSchema = {
    showActionColumn: true,
    columns: [
      { field: "id", headerName: "ID" },
      { field: "title", headerName: "Title" },
      { field: "description", headerName: "Description" },
      {
        field: "action",
        cellRender: ActionCellRender,
        isAction: true,
        actions: [
          {
            name: "edit",
            icon: IconPencil,
            props: {
              //   color:"red"
            },
          },
        ],
        actionMenu: [
          {
            name: "delete",
            label: "Delete data",
            icon: IconTrash,
            props: {
              color: "red",
            },
          },
        ],
      },
    ],
  };

  const formSchema = {
    title: "AI Prompt",
    display: {
      mode: ENUM_FORM_DISPLAY.LINK,
      size: "xl", //xs, sm, xl  ....100%
      position: "right",
    },
    apiEntity,
    initialValues,
    layout: {
      containers: [
        {
          key: "section-basic",
          parent: null,
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Prompt Info",
            description: "Please fill in the detail of the AI Prompt",
            withBorder: false,
            minHeight: "0px",
          },
        },
        {
          key: "section-message",
          parent: null,
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Messages",
            description: "Please fill in the detail of the AI Prompt",
          },
        },
      ],
      fields: [
        {
          name: "id",
          component: TextInput,
          parent: "section-basic",
          props: { required: true, label: "ID" },
        },
        {
          name: "title",
          component: TextInput,
          parent: "section-basic",
          props: { required: true, label: "Title" },
        },
        {
          name: "description",
          component: TextInput,
          parent: "section-basic",
          props: { label: "Description" },
        },

        {
          name: "message",
          component: Textarea,
          parent: "section-message",
          props: {
            required: true,
            minRows: 30,
            autosize: true,
          },
        },
      ],
    },
  };

  return (
    <PageList
      title="AI Prompt"
      apiEntity={apiEntity}
      initialValues={initialValues}
      tableSchema={tableSchema}
      formSchema={formSchema}
    />
  );
};

export default AIPrompt;
